var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ebf0c5f2a1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.203125 5.203125 L 369.796875 5.203125 L 369.796875 369.796875 L 5.203125 369.796875 Z M 5.203125 5.203125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6b356f66e2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 5.203125 C 86.820312 5.203125 5.203125 86.820312 5.203125 187.5 C 5.203125 288.179688 86.820312 369.796875 187.5 369.796875 C 288.179688 369.796875 369.796875 288.179688 369.796875 187.5 C 369.796875 86.820312 288.179688 5.203125 187.5 5.203125 Z M 187.5 5.203125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5a173eda48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.203125 0.203125 L 364.796875 0.203125 L 364.796875 364.796875 L 0.203125 364.796875 Z M 0.203125 0.203125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "27d209fd40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 182.5 0.203125 C 81.820312 0.203125 0.203125 81.820312 0.203125 182.5 C 0.203125 283.179688 81.820312 364.796875 182.5 364.796875 C 283.179688 364.796875 364.796875 283.179688 364.796875 182.5 C 364.796875 81.820312 283.179688 0.203125 182.5 0.203125 Z M 182.5 0.203125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "68c509f84e"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 365,
    y: 0,
    height: 365
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "24fc75cfd0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 110.554688 119.113281 L 264.304688 119.113281 L 264.304688 255.613281 L 110.554688 255.613281 Z M 110.554688 119.113281 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ebf0c5f2a1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6b356f66e2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 5, 5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#68c509f84e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5a173eda48)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#27d209fd40)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M 0.203125 0.203125 L 364.796875 0.203125 L 364.796875 364.796875 L 0.203125 364.796875 Z M 0.203125 0.203125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#24fc75cfd0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f1f22",
    d: "M 148.179688 132.792969 C 148.179688 129.015625 151.226562 125.953125 155.015625 125.953125 L 257.59375 125.953125 C 261.371094 125.953125 264.433594 128.988281 264.433594 132.792969 C 264.433594 136.570312 261.382812 139.628906 257.59375 139.628906 L 155.015625 139.628906 C 151.242188 139.628906 148.179688 136.59375 148.179688 132.792969 Z M 148.179688 187.5 C 148.179688 183.722656 151.226562 180.660156 155.015625 180.660156 L 257.59375 180.660156 C 261.371094 180.660156 264.433594 183.695312 264.433594 187.5 C 264.433594 191.277344 261.382812 194.339844 257.59375 194.339844 L 155.015625 194.339844 C 151.242188 194.339844 148.179688 191.300781 148.179688 187.5 Z M 148.179688 242.207031 C 148.179688 238.429688 151.226562 235.367188 155.015625 235.367188 L 257.59375 235.367188 C 261.371094 235.367188 264.433594 238.402344 264.433594 242.207031 C 264.433594 245.984375 261.382812 249.046875 257.59375 249.046875 L 155.015625 249.046875 C 151.242188 249.046875 148.179688 246.011719 148.179688 242.207031 Z M 124.242188 146.46875 C 116.691406 146.46875 110.566406 140.34375 110.566406 132.792969 C 110.566406 125.238281 116.691406 119.113281 124.242188 119.113281 C 131.796875 119.113281 137.921875 125.238281 137.921875 132.792969 C 137.921875 140.34375 131.796875 146.46875 124.242188 146.46875 Z M 124.242188 201.175781 C 116.691406 201.175781 110.566406 195.054688 110.566406 187.5 C 110.566406 179.945312 116.691406 173.824219 124.242188 173.824219 C 131.796875 173.824219 137.921875 179.945312 137.921875 187.5 C 137.921875 195.054688 131.796875 201.175781 124.242188 201.175781 Z M 124.242188 255.882812 C 116.691406 255.882812 110.566406 249.761719 110.566406 242.207031 C 110.566406 234.652344 116.691406 228.53125 124.242188 228.53125 C 131.796875 228.53125 137.921875 234.652344 137.921875 242.207031 C 137.921875 249.761719 131.796875 255.882812 124.242188 255.882812 Z M 124.242188 255.882812 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientList);
export default __webpack_public_path__ + "static/media/ClientList.bc62f865f869f53391ad5b80ee8a411a.svg";
export { ForwardRef as ReactComponent };